import React from 'react';
import { List, Datagrid, TextField, DateField, TextInput, Filter, DateInput, downloadCSV, FunctionField } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import DeviceLogShow from './devicelogShow';
import DeviceLogActions from './deviceLogActions';
import { useMediaQuery, Chip } from '@mui/material';

export const DeviceLogList = ({ permissions, ...props }) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
    <List empty={false} filters={<DeviceLogFilter />} actions={<DeviceLogActions permissions={permissions} />} sort={{ field: '_updatedAt', order: 'DESC' }} exporter={exporter}   {...props}>
            { isSmall ? (
                <Datagrid rowClick="expand" expand={<DeviceLogShow />} bulkActionButtons={false}>
                    <DateField source="_updatedAt" showTime locales="it-IT" />
                    <FunctionField label="Operazione" render={record => { 
                        switch (record.operation) {
                            case 1:
                                return <Chip label={"Creato"} variant="outlined" size="small" color="primary" />;
                            case 2:
                                return <Chip label={"Aggiornato"} variant="outlined" size="small" color="primary" />;
                            case 3:
                                return <Chip label={"Cancellato"} variant="outlined" size="small" color="error" />;
                            default:
                                return undefined;
                        }
                     }} />
                    <TextField source="serial_number_tim" />
                </Datagrid>
            ) : (
                <Datagrid rowClick="expand" expand={<DeviceLogShow />} bulkActionButtons={false}>
                    <DateField source="_updatedAt" showTime locales="it-IT" />
                    <FunctionField label="Operazione" render={record => { 
                        switch (record.operation) {
                            case 1:
                                return <Chip label={"Creato"} variant="outlined" size="small" color="primary" />;
                            case 2:
                                return <Chip label={"Aggiornato"} variant="outlined" size="small" color="primary" />;
                            case 3:
                                return <Chip label={"Cancellato"} variant="outlined" size="small" color="error" />;
                            default:
                                return undefined;
                        }
                     }} />
                    <TextField source="serial_number_tim" />
                    <TextField source="workrequestid" />
                    <TextField source="cod_terr_sap" />
                    {permissions === 'administrator' && <TextField source="codice_impresa_name" />}
                    <TextField source="status.descrizione" />
                </Datagrid>
            ) }
    </List>
)};

const exporter = devicelogs => {
    const devicesForExport = devicelogs.map(device => {
        const { ...deviceForExport } = device;
        deviceForExport.status = device.status && device.status.descrizione;
        deviceForExport.causale = device.causale && device.causale.descrizione;
        deviceForExport.anomalia = device.anomalia && device.anomalia.descrizione;
        deviceForExport['NMU WR'] = device.lista_NMU;
        deviceForExport.status_collaudo_one = device.status_collaudo_one && device.status_collaudo_one.descrizione;
        if(device.note && device.note.includes('\n')) deviceForExport.note = device.note.replaceAll('\n',' '); 
        return deviceForExport;
    });
    const csv = convertToCSV({
        data: devicesForExport,
        fields: ['serial_number_tim', 'serial_number_forn', 'operation', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'num_consegna', 'workrequestid', 'externalrefid', 'associated_at', 'associated_by',
            'causale', 'anomalia', 'status', 'wr_prodotti', 'cod_terr_sap', 'cod_nmu', 'codice_impresa_name', 'impianto', 'impianto_regman' , 'mac_address', 'NMU WR', 'note','wr_collaudo_one','impianto_collaudo_one',
            'data_collaudo_one','status_collaudo_one', 'equivalenza_prod_applicabile', 'one_step'] // order fields in the export
    });
    downloadCSV(csv, 'Registro operazioni');
}

const DeviceLogFilter = (props) => (
    <Filter {...props}>
        <TextInput source="workrequestid" />
        <TextInput source="serial_number_tim" style={{ width: '215px' }} />
        <TextInput source="associated_by" />
        <DateInput source="associated_at_gte"/>
        <DateInput source="associated_at_lte"/>
        <TextInput source="impianto" />
        <DateInput source="data_completamento_wr_gte" />
        <DateInput source="data_completamento_wr_lte" />
    </Filter>
);

